import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Hi, I'm Shivansh Vishwakarma`}</h1>
    <p>{`I'm currently a Product Engineer at `}<a parentName="p" {...{
        "href": "https://www.linkedin.com/company/juspay-technologies/mycompany/"
      }}>{`Juspay Technologies`}</a>{` and exploring my interest in the field of Software Engineering`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      